import URI from 'urijs';
import moment from 'moment';

const DATE_FORMAT = "YYYY-MM-DD";


export default class URL {
  static parseUrlParams(search) {
    return URI(search).search(true);
  }
  static setUrlParams(search, changeDataCb) {
    return URI(search).search(changeDataCb).search();
  }

  /**
   * @param dateStr {String}
   * @return {moment}
   * @private
   */
  static parseDate(dateStr) {
    if (!dateStr) { return null; }
    const date = moment.utc(dateStr, DATE_FORMAT);
    return date.isValid() ? date : null
  }

  /**
   * @param data {object}
   * @param name {string}
   * @param date {moment}
   * @return {object}
   * @private
   */
  static setUrlDateParam(data, name, date) {
    if (date && date.isValid()) {
      data[name] = date.format(DATE_FORMAT);
    } else {
      delete data[name];
    }
    return data
  }

  static setUrlArrayParam(data, name, value) {
    if (value && value.length) {
      data[name] = value.join(',');
    } else {
      delete data[name];
    }
    return data
  }

  static setUrlStringParam(data, name, value) {
    if (value === '' || value === null || value === undefined) {
      delete data[name];
    } else {
      data[name] = value;
    }
    return data
  }

  static setUrlObjectParam(data, name, value) {
    if (!this._isEmpty(value)) {
      data[name] = JSON.stringify(value);
    } else {
      delete data[name];
    }
    return data;
  }

  static _isEmpty(obj) {
    for (const prop in obj) {
      return false;
    }
    return true;
  }

}


// WEBPACK FOOTER //
// ./src/components/utils/url.js